import { Tooltip, TooltipProps } from "@mui/material";
import React from "react";

export interface IProps extends TooltipProps {
  hide?: boolean;
}

export function DCTooltip({ hide, ...rest }: IProps) {
  return hide ? <>{rest.children}</> : <Tooltip {...rest}><span>{rest.children}</span></Tooltip>
}